import {push} from 'react-router-redux';
import axios from 'axios';
import {LOGIN_URL} from '../../config';
import {
    AUTH_ERROR,
    AUTHENTICATED_USER,
    SET_PERMISSIONS,
    UNAUTHENTICATED_USER
} from './types';
import _forIn from 'lodash/forIn';
import _startsWith from 'lodash/startsWith';
import {beginAjaxCall, endAjaxCall} from '../layout/actions';

export function signInUser({username, password}) {
    return dispatch => {
        dispatch(beginAjaxCall());
        axios
            .post(`${LOGIN_URL}`, {username: username, password: password})
            .then(response => {
                dispatch({
                    type: AUTHENTICATED_USER,
                    payload: response.data.user
                });
                dispatch({
                    type: SET_PERMISSIONS,
                    payload: response.data.permissions
                });
                localStorage.setItem('token', response.data.token);
                localStorage.setItem(
                    'permissions',
                    JSON.stringify(response.data.permissions)
                );
                localStorage.setItem(
                    'user',
                    JSON.stringify(response.data.user)
                );
                dispatch(endAjaxCall());

                // force user to change his password on the 1st login
                if (response.data.user.password_updated_at === null) {
                    dispatch(push(`/myaccount/${response.data.user.id}`));
                } else {
                    dispatch(push('/dashboard'));
                }
            })
            .catch(() => {
                dispatch(
                    authError('Wrong username or password! Please try again!')
                );
                dispatch(endAjaxCall());
            });
    };
}

export function signOut() {
    return dispatch => {
        _forIn(localStorage, (value, objKey) => {
            if (true === _startsWith(objKey, 'reduxPersist')) {
                localStorage.removeItem(objKey);
            }
        });

        localStorage.removeItem('token');
        localStorage.removeItem('permissions');
        localStorage.removeItem('user');
        localStorage.removeItem('userName');

        window.permissions = null;

        dispatch({type: UNAUTHENTICATED_USER});

        dispatch(push('/login'));
    };
}

export function authError(error) {
    return {
        type: AUTH_ERROR,
        payload: {
            error: error
        }
    };
}



// WEBPACK FOOTER //
// ./src/containers/auth/actions.js